import IWall from 'components/interfaces/IWall';
import IValidationError from './IValidationError';

const validateWoodyWall = (wall: IWall): IValidationError[] => {
  const validationErrors = [];

  if (wall.woodyProfileWidth < 75 || wall.woodyProfileWidth > 215) {
    validationErrors.push({
      message: 'Woody profile width should be in between 75 mm and 215 mm',
      property: 'woodyProfileWidth',
    });
  }

  return validationErrors;
};

export default validateWoodyWall;
